// @flow
import React from "react";
import { localize } from "redux-i18n";
import { ColumnsContainer, SectionComponent } from "@components";
import { formatDateTime } from "@transformers/date";

type Props = $Exact<{
  data: *,
  ...PropsFromLocalize,
}>;

export const ReferralDetailsSection = ({ data, t }: Props) => {
  return (
    <SectionComponent
      id="referral-details"
      title={<h5>{t("REFERRAL_DETAILS")}</h5>}
      wrapperClassName="flex-column m-0"
      className="py-0"
      defaultBorder
    >
      <ColumnsContainer
        rows={[
          {
            columns: [
              {
                data: [
                  [`${t("DATE_REFERRED")}:`, ""],
                  [`${t("REFERRAL_TYPE")}:`, ""],
                  [`${t("REFERRED_BY")}:`, ""],
                  [`${t("REFERRAL_REASON")}:`, ""],
                ],
              },
              {
                data: [
                  [formatDateTime(data.dateReferred), ""],
                  [t(data.referralType), ""],
                  [data.referredBy, ""],
                  [data.referralReason, ""],
                ],
              },
            ],
          },
        ]}
      />
    </SectionComponent>
  );
};

export default localize()(ReferralDetailsSection);
